import React from 'react';
import { Send, Timer, Loader2, ShieldAlert } from 'lucide-react';
import { Button } from '../ui/button';
import { BrandMark } from './BrandMark';
import { fmtClock } from './useCountdown';

export const RunnerTopBar = ({ name, answered, total, left, integrity, saving, onSubmit, submitting }) => {
  const tone = left <= 60 ? 'bg-red-600 text-white animate-pulse' : left <= 300 ? 'bg-amber-100 text-amber-800 border-amber-300' : 'bg-slate-900 text-white';
  const pct = total ? Math.round((answered / total) * 100) : 0;
  const flags = integrity.tab_switches + integrity.paste_blocked;
  return (
    <header className="h-14 shrink-0 bg-white/95 backdrop-blur border-b border-slate-200 px-4 flex items-center gap-5 z-30">
      <BrandMark compact />
      <div className="hidden md:block h-7 w-px bg-slate-200" />
      <div className="hidden md:block min-w-0">
        <p className="text-sm font-semibold text-slate-900 truncate">Advanced Excel Assessment</p>
        <p className="text-[11px] text-slate-500 truncate">Candidate: {name}</p>
      </div>
      <div className="flex-1 max-w-sm hidden lg:block">
        <div className="flex justify-between text-[11px] text-slate-500 mb-1">
          <span data-testid="runner-progress-text">{answered}/{total} answered</span>
          <span>{saving ? 'Saving…' : 'All changes saved'}</span>
        </div>
        <div className="h-1.5 bg-slate-100 rounded-full overflow-hidden">
          <div className="h-full bg-emerald-500 transition-[width] duration-500" style={{ width: `${pct}%` }} />
        </div>
      </div>
      <div className="ml-auto flex items-center gap-3">
        {flags > 0 && (
          <span className="hidden sm:inline-flex items-center gap-1.5 text-[11px] font-medium text-amber-700 bg-amber-50 border border-amber-200 px-2.5 py-1 rounded-full"
            data-testid="integrity-flag-count">
            <ShieldAlert className="h-3.5 w-3.5" /> {flags} integrity event{flags > 1 ? 's' : ''}
          </span>
        )}
        <span className={`inline-flex items-center gap-1.5 font-mono text-sm font-semibold px-3 py-1.5 rounded-lg border border-transparent ${tone}`}
          data-testid="test-countdown-timer">
          <Timer className="h-4 w-4" /> {fmtClock(left)}
        </span>
        <Button onClick={onSubmit} disabled={submitting} className="h-9 gap-2 bg-indigo-600 hover:bg-indigo-700 text-white" data-testid="submit-assessment-btn">
          {submitting ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />} Submit
        </Button>
      </div>
    </header>
  );
};

export default RunnerTopBar;
